import React from 'react';
import { Typography, Button, Grid } from '@inplayer-org/inplayer-ui';

// components
import StyledContainer from 'components/StyledContainer';
import BaseModal, { ModalActions } from 'components/Modals/BaseModal';
import { BlueTypography } from 'components/SharedStyledElements';

// types
import { ModalNames } from 'ducks/merchantDucks/modal/types';
import { HeaderWrapper } from 'components/Modals/ConfirmModal';

const { Cell } = Grid;

interface Props {
  isDefault: number;
  handleDelete: (closeModal: () => void) => () => any;
}

const DefaultSetModal = ({ handleDelete, isDefault }: Props) => {
  return (
    <BaseModal
      tag="set_country_set_as_default_modal"
      modalName={ModalNames.DefaultCountry}
      title="Set country set as default"
      render={({ closeModal }: ModalActions) => (
        <>
          {isDefault === 0 ? (
            <>
              <HeaderWrapper>
                <BlueTypography variant="h4">
                  Are you sure you want to remove this country set as default?
                </BlueTypography>
              </HeaderWrapper>
              <HeaderWrapper>
                <Typography variant="p">
                  All assets where the default restriction applies will no longer be geo-restricted.
                </Typography>
              </HeaderWrapper>
            </>
          ) : (
            <>
              <HeaderWrapper>
                <BlueTypography variant="h4">Are you sure you want to set this country set as default?</BlueTypography>
              </HeaderWrapper>
              <HeaderWrapper>
                <Typography variant="p">
                  The default country set will only be applied to assets that do not have their own geo-restrictions.
                </Typography>
              </HeaderWrapper>
            </>
          )}
          <StyledContainer columns={3} alignContent="center" justifyContent="center">
            <Cell middle left={2}>
              <Button tag="button_no" fullWidth onClick={closeModal}>
                Oops, no!
              </Button>
            </Cell>
            <Cell middle left={3}>
              <Button tag="button_yes" fullWidth onClick={handleDelete(closeModal)} buttonModifiers={['buttonPrimary']}>
                Yes!
              </Button>
            </Cell>
          </StyledContainer>
        </>
      )}
    />
  );
};

export default DefaultSetModal;
